import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pgs_savings-wrap" }
const _hoisted_2 = { class: "savings_info-row" }
const _hoisted_3 = { class: "savings_info-col monthly" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "label-title" }, "Miesięcznie", -1)
const _hoisted_5 = { class: "savings" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ins", null, "zł", -1)
const _hoisted_7 = { class: "savings_info-col annualy" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "label-title" }, "Rocznie", -1)
const _hoisted_9 = { class: "savings" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ins", null, "zł", -1)

import { IonCol, IonTitle } from '@ionic/vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'PgsSavings',
  props: {
	savings: {
		type: Number,
		default: 0,
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCol), { class: "pgs_savings" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonTitle), { class: "main-title" }, {
          default: _withCtx(() => [
            _createTextVNode("Oszczędność")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(Number(__props.savings).toFixed(2)) + " ", 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(Number(__props.savings * 12).toFixed(2)) + " ", 1),
              _hoisted_10
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})